import '../../style/index.less';
import '../../popover/style';



/** WEBPACK FOOTER **
 ** ./components/popconfirm/style/index.js
 **/